import { PolIcon } from "components/PolIcon/policon";
import React from 'react';
import { useHistory } from "react-router-dom";
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";
import { resolveUrl } from "v4/features/front/navigation/utils/route.utils";
import { usePolTranslation } from "v4/hooks/usePolTranslation";

export default function ProspectTabBackButton() {
    const { t } = usePolTranslation();
    const { push } = useHistory();
    const { currentRoute } = useNavigation();
    const { params: { prospect }, route } = currentRoute

    const onClick = () => {
        push(`/${resolveUrl(route?.url, { prospect })}`);
    }

    return (
        <div className="prospect-tab__prospect__header__back" onClick={onClick}>
            <PolIcon icon='return'/>
            <span>{t('retour')}</span>
        </div>
    )
}
